import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import Footer from './Footer';

import './Layout.scss';

const Layout = ({children, marginRight, solidHeader}) => (
  <div className={marginRight ? 'margin-right' : undefined}>
    <Header marginRight={marginRight} solid={solidHeader} />
    {children}
    <Footer />
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  marginRight: PropTypes.bool,
  solidHeader: PropTypes.bool,
};

Layout.defaultProps = {
  marginRight: false,
  solidHeader: false,
};

export default Layout;
